var exports = {
  "kL": "MentionEveryonePopout.module__container___ZUhoSm",
  "wx": "MentionEveryonePopout.module__header___ZUhoSm",
  "QW": "MentionEveryonePopout.module__warningIcon___ZUhoSm",
  "DD": "MentionEveryonePopout.module__title___ZUhoSm",
  "h_": "MentionEveryonePopout.module__description___ZUhoSm",
  "S3": "MentionEveryonePopout.module__roleName___ZUhoSm",
  "g": "MentionEveryonePopout.module__keybindHint___ZUhoSm",
  "Aj": "MentionEveryonePopout.module__keybinds___ZUhoSm",
  "P": "MentionEveryonePopout.module__keybind___ZUhoSm",
};

module.exports = exports;
